import { UIText1, UIHeading1 } from '@cian/ui-kit';
import { ReilableNewbuilding12 } from '@cian/ui-kit/icons';
import * as React from 'react';

import { AuthorFact, IAuthorFactProps } from './components/AuthorFact';
import { AuthorLink } from './components/AuthorLink';
import * as styles from './styles.css';
import * as Analytics from './tracking';

export interface IAuthorPremiumProps {
  offerId: number;
  builderId: number;
  title: string;
  isReliable: boolean;
  logoUrl?: string | null;
  description?: string | null;
  facts?: IAuthorFactProps[] | null;
  authorUrl?: string | null;
}

export const AuthorPremium: React.FC<IAuthorPremiumProps> = ({
  offerId,
  builderId,
  logoUrl,
  title,
  facts,
  isReliable,
  description,
  authorUrl,
}) => {
  return (
    <section className={styles['container']} id="author">
      {logoUrl && <div className={styles['logo']} style={{ backgroundImage: `url(${logoUrl})` }} />}
      <UIText1 fontWeight="bold" color="black_100">
        Автор объявления
      </UIText1>
      <div className={styles['title']}>
        <UIHeading1 color="black_100">{title}</UIHeading1>
      </div>
      {isReliable && (
        <div className={styles['status']}>
          <ReilableNewbuilding12 color="primary_100" />
          <span className={styles['status-title']}>Надежный застройщик</span>
        </div>
      )}
      {facts && facts.length !== 0 && (
        <div className={styles['facts']}>
          {facts.map((fact, index) => (
            <div key={index} className={styles['fact']}>
              <AuthorFact {...fact} />
            </div>
          ))}
        </div>
      )}

      {description && (
        <UIText1>
          <span
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: description }}
          ></span>
        </UIText1>
      )}
      {authorUrl && (
        <div className={styles['link']}>
          <AuthorLink
            url={authorUrl}
            text={'Подробнее о застройщике'}
            onClick={() => Analytics.trackClickCardBuilder(offerId, builderId)}
          />
        </div>
      )}
    </section>
  );
};
